import { RegistrationListTask } from '@/types/tasks';
import { createContext } from 'react';

export type Source = 'task' | 'list' | null;

interface RegistrationsContextType {
  filteredRegistrations: RegistrationListTask[];
  currentRegistrationId: string | null;
  setFilteredRegistrations: (tasks: RegistrationListTask[]) => void;
  setCurrentRegistrationId: (id: string | null) => void;
  getNextRegistration: (currentId: string) => RegistrationListTask | null;
  source: Source;
  setSource: (src: Source) => void;
}

export const RegistrationsContext = createContext<RegistrationsContextType | null>(null);
